<template>
  <div>
    <CommonForm @search="formSearch" :form-json="formjson" />
    <CommonTable
      ref="table"
      :data="tableData"
      :total="total"
      :table-json="tablejson"
      :needPagination="false"
    >
    </CommonTable>
  </div>
</template>

<script>
import tablejson from './Model/Tablejson.Index'
import formjson from './Model/Formjson.Index'
import formTableMixin from '@/mixins/formTableMixin'
export default {
  mixins: [formTableMixin],
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tablejson,
      formjson
    }
  },
  computed: {
    queryApi() {
      return this.type === 'agent'
        ? this.$api.channel.agent_product
        : this.$api.channel.distributor_product
    }
  },
  methods: {
    formSearch(data) {
      const params = {
        ...data
      }
      if (this.type === 'agent') {
        params.agentId = this.$route.query.id
      } else {
        params.distributorId = this.$route.query.id
      }
      this.search(params, null, this.queryApi).then((res) => {
        this.tableData = res.data
      })
    }
  }
}
</script>
